/** @jsx jsx */
import React, { useContext } from 'react';
import { jsx } from '@emotion/core';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from '@material-ui/core';
import Button from 'components/Button';
import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';
import ConsumerSearchContext from 'features/ReusableConsumerSearch/ConsumerSearchContext';

interface DialogPropTypes {
  extendSession: () => void;
  endSession: () => void;
  timeoutTime: number;
}

const TimeoutDialog: React.FC<DialogPropTypes> = props => {
  const { extendSession, endSession, timeoutTime } = props;
  const { i18nPrefix } = useContext(ConsumerSearchContext);
  const tMd = useMarkdownTranslate();
  const formattedTimeoutTime = Math.floor(timeoutTime / 60);

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="xs"
      aria-labelledby="timeout-warning-dialog-title"
      open={true}
    >
      <DialogTitle id="timeout-warning-dialog-title">
        {tMd('dsp.appTimeout.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {tMd(`${i18nPrefix}dsp.appTimeout.warning`, {
            timeoutTime: formattedTimeoutTime,
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={endSession}>
          {tMd('dsp.appTimeout.cancel')}
        </Button>
        <Button variant="text" autoFocus onClick={extendSession}>
          {tMd('dsp.appTimeout.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

interface PropTypes {
  warned: boolean;
  extendSession: () => void;
  endSession: () => void;
  timeoutTime: number;
}
const DspTimeoutModalView: React.FC<PropTypes> = props => {
  const { warned, extendSession, endSession, timeoutTime } = props;
  return (
    <React.Fragment>
      {warned && (
        <TimeoutDialog
          extendSession={extendSession}
          endSession={endSession}
          timeoutTime={timeoutTime}
        />
      )}
      {props.children}
    </React.Fragment>
  );
};

export default DspTimeoutModalView;
